import {Directive, Input, TemplateRef, ViewContainerRef} from "@angular/core";
import {ColActionId, DetailAction} from "@pt/pt-models";

@Directive({
  selector: '[ptIfDeleteAction]',
  standalone: true
})
export class IfDeleteActionDirective {
  private actions: DetailAction[] = [];
  private findAction?: DetailAction;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {
  }

  @Input()
  set ptIfDeleteAction(actions: DetailAction[]) {
    this.actions = actions;
    this.updateView();
  }

  updateView() {
    if (this.checkDeleteAction()) {
      this.viewContainer.createEmbeddedView(this.templateRef, {action: this.findAction});
    } else {
      this.viewContainer.clear();
    }
  }

  checkDeleteAction() {
    this.findAction = this.actions.find(action => action.id === ColActionId.delete && action.visible);
    return !!this.findAction
  }
}
